import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=7256ada6"
import script from "./minimal.vue?vue&type=script&lang=js"
export * from "./minimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports